import { GlobalState } from 'store'
import { NegotiationStatus, NegotiationType, NegotiationSubscriptionIdentifier } from 'api'
import { Selector } from 'react-redux'

export enum NegotiationFilter {
  InitiatorOnly,
  ResponderOnly,
  All
}

export interface NegotiationSelectionOptions {
  negotiationFilter: NegotiationFilter
  statusSelector?: Selector<GlobalState, NegotiationStatus[]>
  collectionIdSelector?: Selector<GlobalState, string | null>
  negotiationTypes?: NegotiationType[]
  hideNegotiationSentToStaging?: boolean
  subscriptionIdentifier?: NegotiationSubscriptionIdentifier
}
